// material-ui
import { styled, useTheme } from '@mui/material/styles';
import {
    Container,
    Grid,
    Typography,
    OutlinedInput,
    Tooltip,
    IconButton,
    Box,
    Card,
    CardActions,
    CardContent,
    Button
} from '@mui/material';
import React, { useState } from 'react';
import SendTwoToneIcon from '@mui/icons-material/SendTwoTone';

// project imports
import AppBar from 'ui-component/extended/AppBar';
import { gridSpacing } from 'store/constant';
import SubCard from 'ui-component/cards/SubCard';

//third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
// assets
import headerBackground from 'assets/images/landing/bg-header.jpg';

const HeaderWrapper = styled('div')(({ theme }) => ({
    backgroundImage: `url(${headerBackground})`,
    backgroundSize: '100% 600px',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
    textAlign: 'center',
    paddingTop: 30,
    [theme.breakpoints.down('md')]: {
        paddingTop: 0
    }
}));

// ============================|| SAAS PAGES - PRIVCY POLICY ||============================ //

const SearchResult = () => {
    const theme = useTheme();
    const [message, setMessage] = useState();
    return (
        <HeaderWrapper>
            <AppBar />
            <Container>
                <Grid container justifyContent="left" spacing={gridSpacing}>
                    <Grid item sm={10} md={7} sx={{ mt: { md: 12.5, xs: 2.5 }, mb: { md: 8, xs: 2.5 } }}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <Typography
                                    variant="h3"
                                    component="div"
                                    color="white"
                                    sx={{
                                        fontSize: '3.5rem',
                                        fontWeight: 900,
                                        lineHeight: 1.4,
                                        [theme.breakpoints.down('md')]: { fontSize: '1.8125rem', marginTop: '80px' }
                                    }}
                                >
                                    KẾT QUẢ TÌM KIẾM
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    variant="h5"
                                    component="div"
                                    sx={{ fontWeight: 400, lineHeight: 1.4, [theme.breakpoints.up('md')]: { my: 0, mx: 12.5 } }}
                                    color="white"
                                >
                                    Kết quả tìm kiếm cho "Youteach.AI là gì"
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justifyContent="center" sx={{ '&> .MuiGrid-root > div': { height: '100%' } }}>
                            <SubCard sx={{ width: '100%' }}>
                                <Grid container>
                                    {/* <Grid item xs={12}>
                                <div className="min-h-full min-w-full">
                                    <div
                                        className={`transition-all duration-200 ${
                                            !isMobile ? `ml-0 ${!navOpen ? '-mt-5 md:mx-auto lg:mx-auto' : 'md:ml-72'}` : 'ml-0 md:ml-16'
                                        }`}
                                    >
                                        <div className="flex flex-col justify-center bg-white p-4  md:flex-row">
                                            {.length > 0 && !hasScrolledToLast && (
                                                <button
                                                    onClick={scrollIntoView}
                                                    aria-label="scroll to bottom"
                                                    className="fixed bottom-32 right-14 z-10 flex h-7 w-7  items-center justify-center rounded-full border-[0.5px] border-gray-alpha bg-gray-100 bg-opacity-50 md:h-9 md:w-9 md:bg-opacity-100 "
                                                >
                                                    <img src={ArrowDown} alt="arrow down" className="h4- w-4 opacity-50 md:h-5 md:w-5" />
                                                </button>
                                            )}

                                            {.length > 0 && (
                                                <div className="mt-20 flex flex-col bg-white transition-all  md:w-3/4">
                                                    {queries.map((query, index) => {
                                                        return (
                                                            <Fragment key={index}>
                                                                <ConversationBubble
                                                                    className={'last:mb-27 mb-7'}
                                                                    key={`${index}QUESTION`}
                                                                    message={query.prompt}
                                                                    type="QUESTION"
                                                                    sources={query.sources}
                                                                ></ConversationBubble>
                                                                {prepResponseView(query, index)}
                                                            </Fragment>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                            {queries.length === 0 && <Hero className="mt-24 h-[100vh] md:mt-52"></Hero>}
                                            <div className="relative bottom-0 flex w-10/12 flex-col items-end self-center pt-3 md:fixed md:w-[65%]">
                                                <div className="flex h-full w-full" style={{ paddingBottom: '30px' }}>
                                                    <div
                                                        id="inputbox"
                                                        ref={inputRef}
                                                        tabIndex={1}
                                                        placeholder="Type your message here..."
                                                        contentEditable
                                                        onPaste={handlePaste}
                                                        className={`border-000000 overflow-x-hidden; max-h-24 min-h-[2.6rem] w-full overflow-y-auto whitespace-pre-wrap rounded-3xl border bg-white py-2 pl-4 pr-9 text-base leading-7 opacity-100 focus:outline-none`}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' && !e.shiftKey) {
                                                                e.preventDefault();
                                                                if (inputRef.current?.textContent && status !== 'loading') {
                                                                    handleQuestion(inputRef.current.textContent);
                                                                    inputRef.current.textContent = '';
                                                                }
                                                            }
                                                        }}
                                                    ></div>
                                                    {status === 'loading' ? (
                                                        <img
                                                            src={Spinner}
                                                            className="relative bottom-[7px] right-[38px] -mr-[30px] animate-spin cursor-pointer self-end"
                                                        ></img>
                                                    ) : (
                                                        <div className="relative bottom-[7px] right-[43px] -mr-[35px] h-[35px] w-[35px] cursor-pointer self-end rounded-full hover:bg-gray-3000">
                                                            <img
                                                                className="ml-[9px] mt-[9px]"
                                                                onClick={() => {
                                                                    if (inputRef.current?.textContent) {
                                                                        handleQuestion(inputRef.current.textContent);
                                                                        inputRef.current.textContent = '';
                                                                    }
                                                                }}
                                                                src={Send}
                                                            ></img>
                                                        </div>
                                                    )}
                                                </div> */}
                                    {/* <p className="text-gray-595959 w-[100vw] self-center bg-white p-5 text-center text-xs md:w-full"></p> */}
                                    {/* </div>
                                        </div>
                                    </div>
                                </div>
                            </Grid> */}
                                    <PerfectScrollbar
                                        style={{
                                            width: '100%',
                                            height: '400px',
                                            overflowX: 'hidden',
                                            minHeight: '400px'
                                        }}
                                        // containerRef={(ref) => {
                                        //     setScrollEl(ref);
                                        // }}
                                    >
                                        <Box>
                                            <CardContent sx={{ width: '100%' }}>
                                                {/* {queries.length > 0 && !hasScrolledToLast && (
                                        <button
                                            onClick={scrollIntoView}
                                            aria-label="scroll to bottom"
                                            className="fixed bottom-32 right-14 z-10 flex h-7 w-7  items-center justify-center rounded-full border-[0.5px] border-gray-alpha bg-gray-100 bg-opacity-50 md:h-9 md:w-9 md:bg-opacity-100 "
                                        >
                                            <img src={ArrowDown} alt="arrow down" className="h4- w-4 opacity-50 md:h-5 md:w-5" />
                                        </button>
                                    )} */}
                                                {/* <Box sx={{ p: 3, pt: 0 }}>
                                            {queries.length > 0 && (
                                                <Grid xs={12}>
                                                    {queries.map((query, index) => {
                                                        return (
                                                            <Box key={index}>
                                                                <ConversationBubble
                                                                    className={'mb-2'}
                                                                    key={`${index}QUESTION`}
                                                                    message={query.prompt}
                                                                    type="QUESTION"
                                                                    sources={query.sources}
                                                                ></ConversationBubble>
                                                                {prepResponseView(query, index)}
                                                            </Box>
                                                        );
                                                    })}
                                                    <span ref={scrollRefChat} />
                                                </Grid>
                                            )}
                                            {queries.length === 0 && <Hero className="h-[100vh]"></Hero>}
                                        </Box> */}
                                            </CardContent>
                                        </Box>
                                    </PerfectScrollbar>
                                    <Grid container alignItems="center">
                                        <Grid
                                            item
                                            xs={12}
                                            padding={0}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <OutlinedInput
                                                multiline={true}
                                                size="small"
                                                // ref={inputRef}
                                                tabIndex={1}
                                                // fullWidth
                                                sx={{ width: '90%' }}
                                                autoFocus={false}
                                                // contentEditable
                                                // value={isRecording === true ? 'Đang nghe...' : message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                // onPaste={handlePaste}
                                                onKeyDown={(e) => {
                                                    // console.log(doc);
                                                    // if (e.key === 'Enter' && !e.shiftKey) {
                                                    //     e.preventDefault();
                                                    //     if (doc?.name === undefined || doc?.name === 'default' || doc === null) {
                                                    //         setMessage('');
                                                    //         dispatch(
                                                    //             openSnackbar({
                                                    //                 open: true,
                                                    //                 anchorOrigin: { vertical: 'top', horizontal: 'center' },
                                                    //                 message: 'Vui lòng chọn dự án!',
                                                    //                 variant: 'alert',
                                                    //                 alert: {
                                                    //                     color: 'error'
                                                    //                 }
                                                    //             })
                                                    //         );
                                                    //     } else {
                                                    //         if (message && status !== 'loading') {
                                                    //             handleQuestion(message, model);
                                                    //             setMessage('');
                                                    //         }
                                                    //     }
                                                    // }
                                                }}
                                                placeholder="Nhập tin nhắn của bạn ở đây..."
                                                // endAdornment={
                                                //     <InputAdornment position="end">
                                                //         {isMicro && isRecording === false && (
                                                //             <Tooltip title="Sử dụng micro" placement="top" arrow>
                                                //                 <IconButton
                                                //                     disableRipple
                                                //                     onClick={() => start()}
                                                //                     // color="primary"
                                                //                     // onClick={(e) => {
                                                //                     //     if (e.target.value) {
                                                //                     //         handleQuestion(e.target.value);
                                                //                     //         e.target.value = '';
                                                //                     //     }
                                                //                     // }}
                                                //                     aria-label="use micro"
                                                //                 >
                                                //                     <MicIcon />
                                                //                 </IconButton>
                                                //             </Tooltip>
                                                //         )}
                                                //         {isMicro && isRecording === true && (
                                                //             <Tooltip title="Đã nói xong rồi" placement="top" arrow>
                                                //                 <IconButton
                                                //                     disabled={status === 'loading'}
                                                //                     onClick={() => stop()}
                                                //                     // color="primary"
                                                //                     // onClick={(e) => {
                                                //                     //     if (e.target.value) {
                                                //                     //         handleQuestion(e.target.value);
                                                //                     //         e.target.value = '';
                                                //                     //     }
                                                //                     // }}
                                                //                     aria-label="use micro"
                                                //                 >
                                                //                     <StopCircleIcon color="error" />
                                                //                 </IconButton>
                                                //             </Tooltip>
                                                //         )}
                                                //     </InputAdornment>
                                                // }
                                                aria-describedby="search-helper-text"
                                                inputProps={{ 'aria-label': 'weight' }}
                                            />
                                            <Tooltip title="Gửi tin nhắn" placement="top" arrow>
                                                <IconButton
                                                    sx={{ padding: '12px', paddingTop: '16px' }}
                                                    color="primary"
                                                    onClick={(e) => {
                                                        if (message) {
                                                            // handleQuestion(message, model);
                                                            setMessage('');
                                                        }
                                                    }}
                                                    aria-label="send message"
                                                >
                                                    <SendTwoToneIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                        {/* <Grid item xs={1} sx={{ paddingLeft: '8px' }}>
                                        {message === '' && status !== 'loading' && (
                                        <IconButton
                                            sx={{ padding: '12px', paddingTop: '16px' }}
                                            disabled
                                            color="primary"
                                            aria-label="send message"
                                        >
                                            <SendTwoToneIcon />
                                        </IconButton>
                                    )}
                                        {status === 'loading' && <ClipLoader color="#156DA2" />}
                                        {message !== '' && status !== 'loading' && (
                                        <Tooltip title="Gửi tin nhắn" placement="top" arrow>
                                            <IconButton
                                                sx={{ padding: '12px', paddingTop: '16px' }}
                                                color="primary"
                                                onClick={(e) => {
                                                    if (message && status !== 'loading') {
                                                        handleQuestion(message, model);
                                                        setMessage('');
                                                    }
                                                }}
                                                aria-label="send message"
                                            >
                                                <SendTwoToneIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    </Grid> */}
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                    </Grid>
                    <Grid xs={12} sx={{ marginTop: 4, textAlign: 'left' }}>
                        <SubCard sx={{ width: '100%' }}>
                            <Card sx={{ minWidth: 275 }}>
                                <CardContent sx={{ paddingBottom: 0 }}>
                                    <Typography sx={{ fontSize: 14 }} variant="h5" component="div">
                                        YouTeach.AI + WordPress: Biến nội dung WordPress của bạn thành Bot YouTeach.AI
                                    </Typography>
                                    <Typography color="text.secondary" gutterBottom>
                                        YouTeach.AI là một nền tảng AI tiên tiến cung cấp các chatbot tùy chỉnh được hỗ trợ bởi ChatGPT-4 để
                                        tùy chỉnh bằng cách sử dụng nội dung doanh nghiệp của bạn. Chatbot YouTeach.AI hoạt động dựa trên dữ
                                        liệu tùy chỉnh, bạn có thể huấn luyện nó dựa trên nội dung WordPress và dữ liệu kinh doanh của mình
                                        mà không cần viết dù chỉ một […]
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small">Đọc thêm</Button>
                                </CardActions>
                            </Card>
                            <Card sx={{ minWidth: 275 }}>
                                <CardContent sx={{ paddingBottom: 0 }}>
                                    <Typography sx={{ fontSize: 14 }} variant="h5" component="div">
                                        YouTeach.AI + WordPress: Biến nội dung WordPress của bạn thành Bot YouTeach.AI
                                    </Typography>
                                    <Typography color="text.secondary" gutterBottom>
                                        YouTeach.AI là một nền tảng AI tiên tiến cung cấp các chatbot tùy chỉnh được hỗ trợ bởi ChatGPT-4 để
                                        tùy chỉnh bằng cách sử dụng nội dung doanh nghiệp của bạn. Chatbot YouTeach.AI hoạt động dựa trên dữ
                                        liệu tùy chỉnh, bạn có thể huấn luyện nó dựa trên nội dung WordPress và dữ liệu kinh doanh của mình
                                        mà không cần viết dù chỉ một […]
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small">Đọc thêm</Button>
                                </CardActions>
                            </Card>
                            <Card sx={{ minWidth: 275 }}>
                                <CardContent sx={{ paddingBottom: 0 }}>
                                    <Typography sx={{ fontSize: 14 }} variant="h5" component="div">
                                        YouTeach.AI + WordPress: Biến nội dung WordPress của bạn thành Bot YouTeach.AI
                                    </Typography>
                                    <Typography color="text.secondary" gutterBottom>
                                        YouTeach.AI là một nền tảng AI tiên tiến cung cấp các chatbot tùy chỉnh được hỗ trợ bởi ChatGPT-4 để
                                        tùy chỉnh bằng cách sử dụng nội dung doanh nghiệp của bạn. Chatbot YouTeach.AI hoạt động dựa trên dữ
                                        liệu tùy chỉnh, bạn có thể huấn luyện nó dựa trên nội dung WordPress và dữ liệu kinh doanh của mình
                                        mà không cần viết dù chỉ một […]
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small">Đọc thêm</Button>
                                </CardActions>
                            </Card>
                        </SubCard>
                    </Grid>
                </Grid>
            </Container>
        </HeaderWrapper>
    );
};

export default SearchResult;
